import { createGlobalStyle } from 'styled-components';
import variableStyles from '../constants/variables-styles';

// font SamsungInterFace
import SamsungInterFaceLight from '../assets/fonts/SAMSUNG/SamsungInterFace-Light.otf';
import SamsungInterFaceRegular from '../assets/fonts/SAMSUNG/SamsungInterFace-Regular.ttf';
import SamsungInterFaceBold from '../assets/fonts/SAMSUNG/SamsungInterFace-Bold.ttf';
import SamsungInterFaceExtraBold from '../assets/fonts/SAMSUNG/SamsungInterFace-ExtraBold.otf';

// font SamsungOne
import SamsungOneLight from '../assets/fonts/SAMSUNG/SamsungOne-300_v1.0.ttf';
import SamsungOneRegular from '../assets/fonts/SAMSUNG/SamsungOne-400_v1.0.ttf';
import SamsungOneLighter from '../assets/fonts/SAMSUNG/SamsungOne-500_v1.0.ttf';
import SamsungOneBold from '../assets/fonts/SAMSUNG/SamsungOne-600_v1.0.ttf';
import SamsungOneExtraBold from '../assets/fonts/SAMSUNG/SamsungOne-700_v1.0.ttf';

const GlobalStyle = createGlobalStyle`

@font-face {
  font-family: "Samsung InterFace";
  src: url(${SamsungInterFaceLight}) format("truetype");
  font-weight: 300;
}

@font-face {
  font-family: "Samsung InterFace";
  src: url(${SamsungInterFaceRegular}) format("truetype");
  font-weight: 400;
}

@font-face {
  font-family: "Samsung InterFace";
  src: url(${SamsungInterFaceBold}) format("truetype");
  font-weight: 600;
}

@font-face {
  font-family: "Samsung InterFace";
  src: url(${SamsungInterFaceExtraBold}) format("truetype");
  font-weight: 700;
}

 /* Font Samsung One */

@font-face {
  font-family: "Samsung One";
  src: url(${SamsungOneLight}) format("truetype");
  font-weight: 300;
}

@font-face {
  font-family: "Samsung One";
  src: url(${SamsungOneRegular}) format("truetype");
  font-weight: 400;
}

@font-face {
  font-family: "Samsung One";
  src: url(${SamsungOneLighter}) format("truetype");
  font-weight: 500;
}

@font-face {
  font-family: "Samsung One";
  src: url(${SamsungOneBold}) format("truetype");
  font-weight: 600;
}

@font-face {
  font-family: "Samsung One";
  src: url(${SamsungOneExtraBold}) format("truetype");
  font-weight: 700;
}

body {
  font-family: "Samsung InterFace", sans-serif;
}

h1 {
  font-family: "Samsung InterFace", sans-serif;
  color: ${variableStyles.primaryBasic};
  font-size:  ${variableStyles.fs30};
  font-weight: ${variableStyles.fwBold};
  line-height: ${variableStyles.lh30};
  display: block;
}

h2 {
  font-family: "Samsung InterFace", sans-serif;
  color: ${variableStyles.primaryBasic};
  font-size:  ${variableStyles.fs22};
  font-weight: ${variableStyles.fwBold};
  line-height: ${variableStyles.lh26};
  display: block;
}

h3 {
  font-family: "Samsung InterFace", sans-serif;
  color: ${variableStyles.primaryBasic};
  font-size:  ${variableStyles.fs20};
  font-weight: ${variableStyles.fwBold};
  line-height: ${variableStyles.lh24};
  display: block;
}

h4 {
  font-family: "Samsung InterFace", sans-serif;
  color: ${variableStyles.primaryBasic};
  font-size:  ${variableStyles.fs18};
  font-weight: ${variableStyles.fwBold};
  line-height: ${variableStyles.lh20};
  display: block;
}

.title{
  font-family: "Samsung One", sans-serif;
  color: ${variableStyles.primaryBasic};
  font-size:  ${variableStyles.fs16};
  font-weight: ${variableStyles.fwBold};
  line-height: ${variableStyles.lh20};
  letter-spacing: ${variableStyles.letterSpacing_0};
}

.body-1{
  font-family: "Samsung One", sans-serif;
  color: ${variableStyles.primaryBasic};
  font-size:  ${variableStyles.fs14};
  font-weight: ${variableStyles.fwRegular};
  line-height: ${variableStyles.lh17};
  letter-spacing: ${variableStyles.letterSpacing_1};
}

.body-2{
  font-family: "Samsung One", sans-serif;
  color: ${variableStyles.primaryBasic};
  font-size:  ${variableStyles.fs14};
  font-weight: ${variableStyles.fwSemiBold};
  line-height: ${variableStyles.lh20};
  letter-spacing: ${variableStyles.letterSpacing_1};
}

.caption-1{
  font-family: "Samsung InterFace", sans-serif;
  color: ${variableStyles.primaryBasic};
  font-size:  ${variableStyles.fs12};
  font-weight: ${variableStyles.fwBold};
  line-height: ${variableStyles.lh24};
  letter-spacing: ${variableStyles.letterSpacing_2};

}

.caption-2{
  font-family: "Samsung InterFace", sans-serif;
  color: ${variableStyles.primaryBasic};
  font-size:  ${variableStyles.fs12};
  font-weight: ${variableStyles.fwRegular};
  line-height: ${variableStyles.lh14};
  letter-spacing: ${variableStyles.letterSpacing_2};
}

.caption-3{
  font-family: "Samsung InterFace", sans-serif;
  color: ${variableStyles.backgroundBasic};
  font-size:  ${variableStyles.fs30};
  font-weight: ${variableStyles.fwBold};
  line-height: ${variableStyles.lh30};
}

.text-button{
  font-family: "Samsung InterFace", sans-serif;
  color: ${variableStyles.primaryBasic};
  font-size:  ${variableStyles.fs14};
  font-weight: ${variableStyles.fwBold};
  line-height: ${variableStyles.lh20};
  letter-spacing: ${variableStyles.letterSpacing_3};
  text-transform: uppercase;
}

.subdued{
  color: ${variableStyles.backgroundBasic6} !important;
  font-size:  ${variableStyles.fs12};
  line-height: ${variableStyles.lh16};
}

.unit-price{
  text-decoration-line: underline;
  margin-left: 5px;
}
.discount-price{
  text-decoration: line-through;
}

@media screen and (device-aspect-ratio: 375/667) {
    select, textarea, span, button, input[type="text"], input[type="password"],
    input[type="datetime"], input[type="datetime-local"],
    input[type="date"], input[type="month"], input[type="time"],
    input[type="week"], input[type="number"], input[type="email"], 
    input[type="tel"], input[type="url"]{ font-size: 16px; }
}

@media screen and (device-aspect-ratio: 9/16) {
    select, textarea, span, button, input[type="text"], input[type="password"],
    input[type="datetime"], input[type="datetime-local"],
    input[type="date"], input[type="month"], input[type="time"],
    input[type="week"], input[type="number"], input[type="email"],
    input[type="tel"], input[type="url"]{ font-size: 16px; }
}

.wrap-end{
  display: flex;
  flex-wrap: wrap;
  align-content: flex-end;
  height: 100%;
}

.wrap-start{
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}

.flex-center{
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-start{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.flex-between{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* &::-webkit-scrollbar-track {
  border: 1px solid #DFE3E8;
  background: #F9FAFB;
  margin: 4px;
}
&::-webkit-scrollbar-thumb {
  background: #C4CDD5;
  border-radius: 4px;
}
&::-webkit-scrollbar {
  width: 6px;
  height: 6px;
} */
`;

export default GlobalStyle;
